import { FormattedMessage } from 'react-intl';

// assets
import { ReadOutlined, ContactsOutlined, BankOutlined, AuditOutlined, ProfileOutlined } from '@ant-design/icons';

// icons
const icons = {
  ContactsOutlined,
  BankOutlined,
  AuditOutlined,
  ProfileOutlined,
  ReadOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const contacts = {
  id: 'contacts_parent',
  title: '',
  type: 'group',
  children: [
    {
      id: 'contacts',
      title: <FormattedMessage id="contacts.directory" />,
      type: 'collapse',
      icon: icons.ReadOutlined,
      children: [
        {
          id: 'users',
          title: <FormattedMessage id="contacts.contacts" />,
          icon: icons.ContactsOutlined,
          url: '/contacts',
          type: 'item'
        },
        {
          id: 'companies',
          title: <FormattedMessage id="contacts.companies" />,
          icon: icons.BankOutlined,
          type: 'item',
          url: '/companies'
        },
        {
          id: 'carSourcing',
          title: 'Car Sourcing',
          icon: icons.BankOutlined,
          type: 'item',
          url: '/carsourcing'
        }
      ]
    }
  ]
};

export default contacts;
